'use client';

import * as React from 'react';

/**
 * @ignore - internal component.
 */
var GridContext = /*#__PURE__*/React.createContext();
if (process.env.NODE_ENV !== 'production') {
  GridContext.displayName = 'GridContext';
}
export default GridContext;